import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-full"
}
const _hoisted_2 = {
  class: "px-5 w-full border-b border-t border-gray-lp-2100 pb-2",
  style: {"padding-top":"8px","margin-top":"6px","height":"36px"}
}
const _hoisted_3 = {
  class: "text-xl font-semibold text-gray-lp-300 align-middle",
  style: {"line-height":"100%"}
}
const _hoisted_4 = {
  class: "px-5 w-full border-b border-t border-gray-lp-2100",
  style: {"padding-top":"8px"}
}
const _hoisted_5 = {
  class: "flex flex-row items-center font-semibold gap-6 text-gray-lp-600",
  ref: "tab-link-container"
}
const _hoisted_6 = { class: "flex flex-row gap-6 py-2" }
const _hoisted_7 = {
  key: 1,
  class: "h-full flex flex-col"
}
const _hoisted_8 = {
  class: "px-5 w-full border-b border-t border-gray-lp-2100 pb-2",
  style: {"padding-top":"8px","margin-top":"6px","height":"36px"}
}
const _hoisted_9 = {
  class: "text-xl font-semibold text-gray-lp-300 align-middle",
  style: {"line-height":"100%"}
}
const _hoisted_10 = {
  class: "px-5 w-full border-b border-t border-gray-lp-2100",
  style: {"padding-top":"8px"}
}
const _hoisted_11 = {
  class: "flex flex-row items-center font-semibold gap-6 text-gray-lp-600",
  ref: "tab-link-container"
}
const _hoisted_12 = { class: "flex-1 min-h-0 overflow-hidden" }
const _hoisted_13 = {
  key: 2,
  class: "h-full flex flex-col"
}
const _hoisted_14 = {
  class: "px-5 w-full border-b border-t border-gray-lp-2100 pb-2",
  style: {"padding-top":"8px","margin-top":"6px","height":"36px"}
}
const _hoisted_15 = {
  class: "text-xl font-semibold text-gray-lp-300 align-middle",
  style: {"line-height":"100%"}
}
const _hoisted_16 = { class: "bg-gray-lp-1000 p-2.5 h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_EmptyState = _resolveComponent("EmptyState")!

  return (_ctx.isLoadingCycles)
    ? (_openBlock(), _createBlock("section", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h1", _hoisted_3, [
            _createVNode(_component_Skeleton, {
              width: "250px",
              height: "24px"
            })
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              (_openBlock(), _createBlock(_Fragment, null, _renderList(8, (i) => {
                return _createVNode(_component_Skeleton, {
                  key: i,
                  width: "143px",
                  height: "32px"
                })
              }), 64))
            ])
          ], 512)
        ])
      ]))
    : (_ctx.cycles.length)
      ? (_openBlock(), _createBlock("section", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("h1", _hoisted_9, _toDisplayString(_ctx.$t('kulioner.merchant.title')), 1)
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cycles, (cycle) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: cycle.id,
                  to: {
            name: 'kulioner-merchant-tab-cycle',
            params: { id: cycle.id }
          }
                }, {
                  default: _withCtx(({
            isActive
          }) => [
                    _createVNode("button", {
                      class: ["font-semibold py-2 px-4", [
              {
                'text-red-lp-100 border-b-2 border-red-lp-100': isActive
              },
              {
                'text-gray-lp-600 border-b-2 border-transparent hover:text-gray-lp-300': !isActive
              }
            ]]
                    }, _toDisplayString(cycle.name), 3)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ], 512)
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_router_view, {
              key: _ctx.$route.params.id
            })
          ])
        ]))
      : (_openBlock(), _createBlock("section", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("h1", _hoisted_15, _toDisplayString(_ctx.$t('kulioner.merchant.title')), 1)
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode(_component_EmptyState, {
              class: "bg-white h-full rounded-xl",
              icon: "noData_empty",
              customHeaderMessage: _ctx.$t('kulioner.merchant.emptyHeader'),
              customMessage: _ctx.$t('kulioner.merchant.emptyMessage')
            }, null, 8, ["customHeaderMessage", "customMessage"])
          ])
        ]))
}